export const PersonalInspectionAvailabilityWindowDataFragment = gql`
  fragment PersonalInspectionAvailabilityWindowDataFragment on PersonalInspectionAvailabilityWindow {
    id
    inspectionAvailabilityWindow {
      ...InspectionAvailabilityWindowDataFragment
    }
  }
`
